var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCinematicBlurFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 6 3.7 7.6h6.5L13.5 6h4.45l3.7 7.6h6.5L24.45 6h4.45l3.7 7.6h6.5L35.4 6H41q1.2 0 2.1.9.9.9.9 2.1v30q0 1.2-.9 2.1-.9.9-2.1.9H7q-1.2 0-2.1-.9Q4 40.2 4 39V9q0-1.2.9-2.1Q5.8 6 7 6Zm9 30h16v-1.6q0-2.1-2.125-3.25T24 30q-3.75 0-5.875 1.15T16 34.4Zm8-9q1.55 0 2.625-1.075T27.7 23.3q0-1.55-1.075-2.625T24 19.6q-1.55 0-2.625 1.075T20.3 23.3q0 1.55 1.075 2.625T24 27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinematicBlurFilled);
export default __webpack_public_path__ + "static/media/cinematic_blur_filled.8caf8a48ba47eca8412f4deed3ea7fc1.svg";
export { ForwardRef as ReactComponent };